import { observable } from 'mobx'
import Api from '@api/experienceShop'

class Store {
  @observable orderDetail = {}

  cooperateOrderDetail = async id => {
    const { data } = await Api.cooperateOrderDetail({ id })
    this.orderDetail = data
  }
}

export default Store
